module.exports = __webpack_public_path__ + "img/icon-telegram.48a57211.svg";